import { ModelMixin } from '@models/core/base-generic.model';

type Type = 'Debit' | 'Credit';
type Status = 'new' | 'funded' | 'sent' | 'complete' | 'failed' | 'nsf';

export class Transaction extends ModelMixin<Transaction>() {
    protected static _resource = 'payroll/companies/:company/payrolls/:payroll/transactions';

    get amount(): number {
        return this._attributes['amount'];
    }

    get failureCode(): string | null {
        return this._attributes['failureCode'];
    }

    get method(): string {
        return this._attributes['method'];
    }

    get payee(): string {
        return this._attributes['payee'];
    }

    get payor(): string {
        return this._attributes['payor'];
    }

    get status(): Status {
        return this._attributes['status'];
    }

    get type(): Type {
        return this._attributes['type'];
    }
}
